import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Payment } from '../models/entities/payment';
import { PaymentRequestDto } from '../models/dtos/payment-request-dto';


@Injectable({
    providedIn: 'root'
})
export class PaymentService {


    constructor(
        private networkService  : LeanNetworkService,
        public userService      : UserService) {
    }

    //------------------------------------------------------------------------------------
    // Payments Get
    //------------------------------------------------------------------------------------
    paymentsGet(serviceCode: string, roleCode: string, personCode: string, partnerCode: string, startDate: Date, endDate: Date) : Promise<Payment[]>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1    = serviceCode;


        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/paymentsGet', request).then(result => {
                return resolve(result.payments);
            });
        });
    }


    //------------------------------------------------------------------------------------
    // Payment Create
    //------------------------------------------------------------------------------------
    paymentSave(payment : Payment) : Promise<Payment>{
        let request: PaymentRequestDto = new PaymentRequestDto(this.userService.userInfo);
        request.payment = payment;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/paymentSave', request).then(result => {
                return resolve(result.payment);
            }, error => {
                reject(error);
            });
        });
    }
    
    //------------------------------------------------------------------------------------
    // Payment Cancel
    //------------------------------------------------------------------------------------
    paymentCancel(paymentCode : string) : Promise<Payment>{
        let request: PaymentRequestDto = new PaymentRequestDto(this.userService.userInfo);
        request.payment = new Payment();
        request.payment.paymentCode = paymentCode;;
        request.payment.canceled = true;;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/paymentSave', request).then(result => {
                return resolve(result.payment);
            });
        });
    }
}
